import { getToolById } from '../apis/ToolRegistration'

export async function getToolInfoListener (message: any) {
    console.log('ATBase: Received request for tool info.')
    message = message || {}
    if (!message.data || typeof message.data !== 'string') {
        return Promise.reject({
            message: 'Invalid input. The provided message must include a data property that is the tool name',
        })
    }

    const toolName = message.data
    if (getToolById(toolName)) {
        return Promise.resolve(getToolById(toolName))
    } else {
        return Promise.reject(`Tool '${toolName}' not found in registry.`)
    }
}
